import { useThree } from '@react-three/fiber'
import type { FilterFunction } from '@react-three/fiber/dist/declarations/src/core/events'
import { useEffect } from 'react'
import { useReorderIntersections } from '~/components/DrawingCanvas/useReorderIntersections'

const setCursorStyle: (fn: FilterFunction) => FilterFunction = fn => (intersections, state) => {
  const filteredIntersections = fn(intersections, state)
  if (filteredIntersections.length > 0) {
    document.body.classList.add('pointer')
  } else {
    document.body.classList.remove('pointer')
  }
  return filteredIntersections
}

export const EventManager = () => {
  const filter = useReorderIntersections()
  const { setEvents } = useThree()
  useEffect(() => setEvents({ filter: setCursorStyle(filter) }), [filter, setEvents])
  return <></>
}
